import {
  CrownOutlined,
  DollarOutlined,
  HighlightOutlined,
  NotificationOutlined,
  PartitionOutlined,
  PercentageOutlined,
  PictureOutlined,
  ThunderboltOutlined
} from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { PERMISSIONS } from 'modules/permission';
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const marketing: NavItemType = {
  id: 'marketing',
  title: <FormattedMessage id="marketing" />,
  type: 'group',
  permission:
    PERMISSIONS.BANNERS.READ |
    PERMISSIONS.DISCOUNTS.READ |
    PERMISSIONS.SPOTLIGHT_ITEMS.READ |
    PERMISSIONS.COLLECTIONS.READ |
    PERMISSIONS.CATEGORIES.READ |
    PERMISSIONS.DELIVERY_CHALLENGES.READ,
  children: [
    {
      id: 'banners',
      title: <FormattedMessage id="banners" />,
      type: 'item',
      url: '/marketing/banners',
      icon: PictureOutlined,
      permission: PERMISSIONS.BANNERS.READ
    },
    {
      id: 'collections',
      title: <FormattedMessage id="collections" />,
      type: 'item',
      url: '/contents/collections',
      icon: PartitionOutlined,
      disabled: false,
      permission: PERMISSIONS.COLLECTIONS.READ
    },
    {
      id: 'compensations',
      title: <FormattedMessage id="compensations" />,
      type: 'item',
      url: '/marketing/compensations',
      icon: DollarOutlined,
      permission: PERMISSIONS.DISCOUNTS.READ
    },
    {
      id: 'delivery-challenges',
      title: <FormattedMessage id="delivery-challenges" />,
      type: 'item',
      url: '/marketing/delivery-challenges',
      icon: ThunderboltOutlined,
      permission: PERMISSIONS.DELIVERY_CHALLENGES.READ
    },
    {
      id: 'discounts',
      title: <FormattedMessage id="discounts" />,
      type: 'item',
      url: '/marketing/discounts',
      icon: PercentageOutlined,
      permission: PERMISSIONS.DISCOUNTS.READ
    },
    {
      id: 'featured-categories',
      title: <FormattedMessage id="featured-categories" />,
      type: 'item',
      url: '/contents/featured-categories',
      icon: PartitionOutlined,
      disabled: false,
      permission: PERMISSIONS.CATEGORIES.READ
    },
    {
      id: 'loyalty',
      title: <FormattedMessage id="loyalty" />,
      type: 'item',
      url: '/marketing/loyalty',
      icon: CrownOutlined,
      permission: PERMISSIONS.DISCOUNTS.READ
    },
    {
      id: 'notifications',
      title: <FormattedMessage id="notifications" />,
      type: 'item',
      url: '/marketing/notifications',
      icon: NotificationOutlined,
      permission: PERMISSIONS.NOTIFICATIONS.READ
    },
    {
      id: 'spotlight-items',
      title: <FormattedMessage id="spotlight-items" />,
      type: 'item',
      url: '/contents/spotlight-items',
      icon: HighlightOutlined,
      permission: PERMISSIONS.SPOTLIGHT_ITEMS.READ
    }
  ]
};

export default marketing;
